import { PageAccess } from 'types/user'
import { PROTECTED_PAGES } from 'utils/constants'

/**
 * Verifies the user have access to page or not
 */
const checkPageAccess = (pageId?: string, permissionsList?: PageAccess[]) => {
  const access = { page: null, isEditor: false }
  if (!permissionsList || !pageId) return access

  return (
    permissionsList.find((permission) => permission.page === pageId) || access
  )
}

/**
 * Give the page info by passing path name
 */
const getPageInfoByPathName = (path: string) => {
  const parentPath = `/${path?.split('/')[1]}` || ''

  return PROTECTED_PAGES.find((page) => page.path === parentPath)
}

export { checkPageAccess, getPageInfoByPathName }
